<template>
   <v-container fluid>
    <v-row>
      <v-col xs12 md6 offset-md3>
        <v-card>
          <v-toolbar>
            <v-toolbar-title>忘記密碼</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-text-field
              label="帳號"
              v-model="account"
              hint="請輸入您的帳號"
              class="mt-5 input-group"
              required
            />

            <v-card-row actions>
              <v-btn small primary dark v-on:click.native="validation()">送出</v-btn>
            </v-card-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapMutations } from 'vuex'
  import api from '../api'

  export default {

    name: 'ForgotPassword',

    data () {
      return {
        account: ''
      }
    },

    created () {
      this.initBreadcrumb()
      this.addBreadcrumb({
        text: '忘記密碼',
        link: '/forgot_password'
      })
    },

    methods: {
      ...mapMutations([
        'addBreadcrumb',
        'initBreadcrumb',
        'setErrorMessage'
      ]),

      submit () {
        var self = this
        api.Account
          .ForgotPassword(this.account)
          .then((response) => {
            self.setErrorMessage('修改密碼信已寄出，請檢查您的電子信箱')
            self.$router.push('/login')
          })
      },

      validation () {
        if (this.account === '') {
          this.setErrorMessage('請輸入您的電子信箱')
          window.document.body.scrollTop = 0
        } else {
          this.submit()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ForgotPassword.vue?1cff6fbb